import { Box, Typography } from '@mui/material';
import Grid from 'components/core/Grid';

import { ContentSection, UserTestimonial, DividerTemp } from './styles';
import { hostReview3850, hostReview733, hostReview848, tempProfileIcon } from 'config/imageUrls';

const UserTestimonials = () => {
  return (
    <>
      <ContentSection>
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <Typography variant="h2" mb={2}>
              Comments From Property Hosts
            </Typography>

            <Grid container spacing={4}>
              <Grid item xs={12} sm={4}>
                <UserTestimonial mb={1}>
                  <img src={hostReview733} />
                  <Box>
                    <Typography>
                      <strong>Jim G.</strong>
                    </Typography>
                  </Box>
                </UserTestimonial>
                <Typography>
                  <i>
                    I&apos;ve rented my place at Whistler for 10+ years through alluraDirect. Terrific service, bringing
                    in high quality guests, supportive, efficient and on top of what is happening in the industry. Happy
                    to support a great local company.
                  </i>
                </Typography>
              </Grid>

              <Grid item xs={12} sm={4}>
                <UserTestimonial mb={1}>
                  <img src={hostReview848} />
                  <Box>
                    <Typography>
                      <strong>Robert W.</strong>
                    </Typography>
                  </Box>
                </UserTestimonial>
                <Typography>
                  <i>
                    Have been using allura direct for 12 years and very happy with their service and easy to use
                    website. Any tech questions are usually answered very fast and often after hours or even weekends.
                  </i>
                </Typography>
              </Grid>

              <Grid item xs={12} sm={4}>
                <UserTestimonial mb={1}>
                  <img src={hostReview3850} />
                  <Box>
                    <Typography>
                      <strong>Kerry G.</strong>
                    </Typography>
                  </Box>
                </UserTestimonial>
                <Typography>
                  <i>
                    I have been using Allura Direct as a customer for almost 10 years and as an owner for just over a
                    year. The service has been exceptional, I would highly recommend Allura Direct.
                  </i>
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </ContentSection>

      <ContentSection>
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <Typography variant="h2" mb={2}>
              Comments From Guests
            </Typography>

            <Grid container spacing={4}>
              <Grid item xs={12} sm={4}>
                <UserTestimonial mb={1}>
                  <img src={tempProfileIcon} />
                  <Box>
                    <Typography>
                      <strong>Sheldon W.</strong>
                    </Typography>
                  </Box>
                </UserTestimonial>
                <Typography>
                  <i>
                    Myself and my family have booked stays in Whistler with alluraDirect over a number of years and they
                    always make it super easy and get everything spot on. Absolutely fantastic customer service, often
                    going above and beyond. Thoroughly recommended!
                  </i>
                </Typography>
              </Grid>

              <Grid item xs={12} sm={4}>
                <UserTestimonial mb={1}>
                  <img src={tempProfileIcon} />
                  <Box>
                    <Typography>
                      <strong>Cindy B.</strong>
                    </Typography>
                  </Box>
                </UserTestimonial>
                <Typography>
                  <i>
                    alluraDirect is a great gateway to booking your holiday. They respond immediately to guest requests.
                    They are local and truly care about the local mountain communities. Keep up the good work!
                  </i>
                </Typography>
              </Grid>

              <Grid item xs={12} sm={4}>
                <UserTestimonial mb={1}>
                  <img src={tempProfileIcon} />
                  <Box>
                    <Typography>
                      <strong>Bob M.</strong>
                    </Typography>
                  </Box>
                </UserTestimonial>
                <Typography>
                  <i>
                    1st time using this company for a trip to Whistler and have never been treated with such excellent
                    customer service! Service is top notch and will answer any question you have...a ton of local
                    knowledge....I will absolutely use them again in the near future.
                  </i>
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </ContentSection>

      <ContentSection>
        <DividerTemp />
      </ContentSection>
    </>
  );
};

export default UserTestimonials;
